/* global VeloxWebView, VeloxViewController */
var RenewPassController = VeloxViewController.create({
    directory : "views/login",
    name: "renewpass",
    container: "main",
    route: "renewpass"
}) ;

RenewPassController.prototype.prepareDataOnEnter = function(token, callback){
    //normal login
    callback(null, {
        token: token 
    });
};

RenewPassController.prototype.onValidate = function(){
    this.view.updateData() ;

    this.view.longTask(function(done){
        this.api.changeUserPasswordToken(this.data.token, this.data.passwordNew, function(err){
            if(err){ 
                return done(null, err);
            }
            this.navigate("/") ;
            window.location.reload() ;
        }.bind(this)) ;
    }.bind(this), function(err1, err){
        if(err === 'INVALID_TOKEN'){ 
            return this.view.error(this.view.tr("login.invalidToken"))  ;
        }
    }.bind(this)) ;
} ;


module.exports = new RenewPassController() ;